import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingBasket = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 10.75v2.5m-3.25-2.5v2.5m6.5-2.5v2.5m-5-9.5L6 7.75m5.75-4 2.25 4m-12.25 0h16.5l-2.5 8.5H4.25l-2.5-8.5Z"
	})]
});
const ForwardRef = forwardRef(SvgShoppingBasket);
export { ForwardRef as ReactComponent };
